const steps = [
  {
    number: "01",
    title: "Site Survey & Needs Assessment",
    desc: "Our engineers visit your facility to assess floor space, utility connections, production volumes, and hygiene requirements. We document all inputs needed for accurate design.",
    icon: "ri-map-pin-2-line",
    image: "/images/food/silos.webp",
  },
  {
    number: "02",
    title: "Custom Engineering & Design",
    desc: "Our draughtsmen produce detailed 2D and 3D engineering drawings for your equipment. You approve the design before a single piece of steel is cut — no surprises.",
    icon: "ri-pencil-ruler-line",
    image: "/images/design/shop-drawing.webp",
  },
  {
    number: "03",
    title: "Precision Fabrication",
    desc: "Using CNC plasma cutting, TIG and MIG welding, and polishing equipment in our Nairobi workshop, we fabricate each unit to the approved drawings with food-grade finishes.",
    icon: "ri-tools-line",
    image: "/images/welding/tig.webp",
  },
  {
    number: "04",
    title: "Delivery, Installation & Commissioning",
    desc: "We transport, install, and commission your equipment on site. Our team integrates utilities, verifies performance, and provides operator training before final handover.",
    icon: "ri-truck-line",
    image: "/images/food/filling.webp",
  },
];

export default function FoodProcess() {
  return (
    <section id="process" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-teal-600 text-xs font-bold uppercase tracking-widest">How We Work</span>
          <h2 className="text-gray-900 text-3xl md:text-4xl font-extrabold mt-3 uppercase tracking-tight">
            From Concept to Commissioning
          </h2>
          <p className="text-gray-500 text-sm mt-4 leading-relaxed">
            Our structured four-stage process ensures every food processing installation
            is delivered on time, on budget, and to the exact specification agreed.
          </p>
        </div>

        {/* Steps */}
        <div className="space-y-16">
          {steps.map((step, i) => (
            <div
              key={step.number}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${i % 2 !== 0 ? "lg:[&>*:first-child]:order-2" : ""}`}
            >
              {/* Image */}
              <div className="w-full h-72 rounded-lg overflow-hidden">
                <img
                  src={step.image}
                  alt={step.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Content */}
              <div>
                <span className="text-teal-100 text-6xl font-extrabold select-none leading-none">{step.number}</span>
                <div className="flex items-center gap-3 mt-2">
                  <div className="w-10 h-10 flex items-center justify-center bg-teal-50 rounded-lg">
                    <i className={`${step.icon} text-lg text-teal-600`}></i>
                  </div>
                  <h3 className="text-gray-900 font-extrabold text-lg uppercase tracking-tight">{step.title}</h3>
                </div>
                <p className="text-gray-500 text-sm leading-relaxed mt-4">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
